import DocumentsGlobalSecurity from './DocumentsGlobalSecurity.component';

export default DocumentsGlobalSecurity;
